import "@babel/polyfill";
import HeaderContainer from "./components/Header/HeaderContainer";
import RecipeFilterContainer from "./components/RecipeFilter/RecipeFilterContainer";
import RecipeSearchContainer from "./components/RecipeSearch/RecipeSearchContainer";
import HeroVideoPlayer from "./HeroVideoPlayer";
import Accordions from "./Accordions";
import GlobalInteractions from "./GlobalInteractions";
import LoadMoreSearchResults from "./LoadMoreSearchResults";

document.addEventListener("DOMContentLoaded", function () {
    HeaderContainer();
    RecipeFilterContainer();
    RecipeSearchContainer();
    new Accordions();
    new HeroVideoPlayer();
    new LoadMoreSearchResults();
    new GlobalInteractions();
});
